import React from 'react'

type Props = {
    header: string,
    text: string,
    gradient?: string,
    children?: React.ReactNode
}

const Section = ({ header, text, gradient, children }: Props) => {
    return (
        <div style={{
            margin: '6em 0 6em 0',
        }}>
            <div style={{
                textAlign: 'left',
                padding: '0 15% 0 15%',
                marginBottom: '3em',
            }}>
                <h2>
                    <span className={gradient ? `gradient-header ${gradient}` : ''}>
                    {header}
                    </span>
                    
                </h2>
                <p style={{
                    lineHeight: '2em',
                    textAlign: 'justify'
                    
                }}>
                    {text}
                </p>
            </div>
            {children}
        </div>
    )
}

export default Section;

